import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

TransportTypeDropdown.propTypes = {
  transportTypes: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function TransportTypeDropdown({ transportTypes, value, onChange, isLoading, disabled = false }) {
  return (
    <Autocomplete
      fullWidth
      size="small"
      value={transportTypes.length > 0 ? transportTypes.find((type) => type.id === value) ?? null : null}
      onChange={(_, newValue) => onChange(newValue?.id ?? null)}
      options={transportTypes}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={(params) => (
        <TextField {...params} label="Select a transport type" autoComplete="off" disabled={disabled} />
      )}
      loading={isLoading}
      disabled={disabled}
    />
  );
}
